import { Directive, TemplateRef } from '@angular/core'
import { AutomationEventTypes, AutomationHandler, AutomationViewGroup } from '@tokeet-frontend/automations'

export interface AutopilotAutomationGroupItemDirectiveContext {
  item: AutomationViewGroup
  index: number
  first: boolean
  last: boolean
  even: boolean
  odd: boolean
  event: AutomationEventTypes
  type: AutomationEventTypes
  handler: AutomationHandler
  name: string
  label: string
}

@Directive({
  selector: '[autopilotAutomationGroupItem]',
  standalone: false,
})
export class AutopilotAutomationGroupItemDirective {
  constructor(public template: TemplateRef<AutopilotAutomationGroupItemDirectiveContext>) {}
}
